import React from "react";
import {
    TextInput,
    SelectInput,
    ArrayInput,
    SimpleFormIterator,
} from 'react-admin';
import required from "../helper/Required";

import CustomAddButton from "./CustomAddButton";
import CustomRemoveButton from "./CustomRemoveButton";

class PhoneArrayInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <ArrayInput
                {...this.props}
                // defaultValue={[
                //     {
                //         phoneType: "MOBILE",
                //         phoneNumber: "+380"
                //     }
                // ]}
            >
                <SimpleFormIterator addButton={<CustomAddButton />} removeButton={<CustomRemoveButton />}>
                    <SelectInput label="Тип контактного телефону" source="phoneType" validate={required.validateRequired} choices={[
                        { id: 'MOBILE', name: 'мобільний' },
                        { id: 'LAND_LINE', name: 'стаціонарний' }
                    ]} />
                    <TextInput formClassName="phone-number-field" label="Номер контактного телефону" source="phoneNumber" placeholder="+380NNNNNNNNN" validate={required.validateRequiredPhone} />
                </SimpleFormIterator>
            </ArrayInput>
        );
    }
}

export default PhoneArrayInput;
